import React 				from 'react';
import PropTypes 			from 'prop-types';
import BLComponent			from '../core/_BLComponent.jsx';

import SimpleProductCard 	from '../common/_SimpleProductCard.jsx';
import HiddenScroll			from '../common/_HiddenScroll.jsx';

export default class CatalogCategoryCard extends BLComponent 
{
	constructor(props) 
	{
		super( props );
	}

	render() 
	{
		const {classes = ''} = this.props;
		const {onClickFunc, image, name, length, background = false} = this.props.data;
		const catClass = ' catalog-category-card--cat-' + this.cleanName();

		return (
			<article className={"card catalog-category-card " + classes + (this.props.data.showChildren ? ' catalog-category-card--active ' : '') + catClass}>
				<div className="card__internal product-card catalog-category-card__internal">
					<button onClick={onClickFunc} className="product-card__main">
						<div className="product-card__image" style={{background: background ? ('#' + background) : 'transparent'}}>
							<div className="product-card__image-internal">
								<img className="product-card__image-item" src={image}/>
							</div>
						</div>
					</button>
					<div className="product-card__meta">
						<button onClick={onClickFunc} className="btn btn--blank text--inherit text--left">{name} {this.props.data.cnt ? "(" + blapp.format.formatNumber(this.props.data.cnt) + ")" : ""}</button>
						{
							this.props.children ?
							<button className="btn btn--blank catalog-category-card__draw-toggle l-margin-left--sm" onClick={() => this.showChildren(!this.props.data.showChildren)}>
								<i className={"fas fa-fw " + (this.props.data.showChildren ? 'fa-chevron-up' : 'fa-chevron-down')}/>
							</button>
							:
							null
						}
					</div>
				</div>
				{
					this.props.data.showChildren ?
					<div className="catalog-category-card__children">
						<div className="mdc-layout-grid catalog-category-card__children-internal">
							<header className="l-flex l-split l-center catalog-category-card__children-title">
								<h3 className=" text--small-title">{name} subcategories ({this.props.children.length})</h3>
								<button className="btn btn--blank l-margin-left text--title" onClick={() => this.showChildren( false )}><i className="far fa-times"/></button>
							</header>
							<div className="mdc-layout-grid__inner">
							{ this.props.data.showChildren && this.props.children ? this.renderChildren() : null }
							</div>
						</div>
					</div>
					:
					null
				}
			</article>
		);
	}

	renderChildren() 
	{
		return 	this.props.children.map(
					(data, key) => 
					{
						const item = {...data, name: data.name + ' (' + blapp.format.formatNumber( data.childrenLength ) + ')'};

						return 	<SimpleProductCard 
									classes="catalog-category-card__child mdc-layout-grid__cell mdc-layout-grid__cell--span-2-desktop mdc-layout-grid__cell--span-2-desktop-l mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone" 
									ratioHeight={true}
									key={key} 
									item={item}
									onClickFunc={data.onClickFunc ? data.onClickFunc : this.props.data.onClickFunc}
								/>
					}
				);
	}

	showChildren( bShow ) 
	{
		if ( this.props.data.onShowChildrenFunc )
			this.props.data.onShowChildrenFunc( bShow );
	}

	cleanName() {
		const {name} = this.props.data;

		const cleaned = name.toLowerCase().replace(/[^A-Za-z0-9 ]+/g, '').replace(/ /g, '-').replace(/[--]+/g, '-');

		return cleaned;
	}
}

CatalogCategoryCard.propTypes = {
		classes:			PropTypes.string
	,	data: 				PropTypes.shape(
								{
					  				image:					PropTypes.string.isRequired
								,	name:					PropTypes.string.isRequired
								,	link:					PropTypes.string.isRequired
								,	cnt:					PropTypes.number
								,	showChildren:			PropTypes.bool
								,	onClickFunc:			PropTypes.func
								,	onShowChildrenFunc:		PropTypes.func
								}
							).isRequired
	,	children: 			PropTypes.arrayOf(
								PropTypes.shape(
									{
						  			image:		PropTypes.string.isRequired
									,	name:		PropTypes.string.isRequired
									,	link:		PropTypes.string.isRequired
									,	childrenLength: PropTypes.number.isRequired
									}
								).isRequired
							)
	
}